import React from 'react';
import {EditOutlined} from '@ant-design/icons';
import {Card, Col, Row} from 'antd';

import '../../assets/less/Card.less';
import {Car} from '../../types/carTypes';
import {labelColSize, dataColSize} from '../../assets/styles';

interface CarDetailsCardProps {
    car: Partial<Car>;
    onEdit?: (state: boolean) => void;
    isStaff: boolean;
}

const CarDetailsCard = ({car, onEdit, isStaff = false}: CarDetailsCardProps) => {

    return (
        <Card
            title="Details"
            bordered={true}
            className="details-card"
            extra={
                (isStaff && onEdit) &&
                <EditOutlined key="edit" onClick={() => onEdit(true)}/>
            }
        >
            <Row>
                <Col {...labelColSize}>
                    <strong>Vehicle Number:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.number}</span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Licence Plate:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">
                        {car.licence_plate || 'N/A'}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Rate Class:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap capitalize">
                        {car.rate_class || 'N/A'}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Nickname:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.friendly_name || 'N/A'}</span>
                </Col>
            </Row>
            {
                isStaff &&
                <Row>
                    <Col {...labelColSize}>
                        <strong>VIN:</strong>
                    </Col>
                    <Col {...dataColSize}>
                        <span className="long-text-wrap">
                            {car.vin || 'N/A'}
                        </span>
                    </Col>
                </Row>
            }
        </Card>
    );
};

export default CarDetailsCard;
